<template>
  <div>
    <div
      v-for="(desserts, subCategoryId) in dessertGroupedBy(dessertByCategory)"
      :key="subCategoryId"
    >
      <h3 v-if="hasSubCategory(subCategoryId)" class="subcategory-name">
        {{ getSubCategoryName(subCategoryId) }}
      </h3>

      <template v-for="(dessert, index) in desserts">
        <li
          :key="index"
          class="product-row food-products"
          :style="{ 'background-color': '#FFFFFF' }"
        >
          <div class="flex-wrapper">
            <h4 class="product-name" :style="{ color: listItemNameColorTheme }">
              {{ translate("name", dessert) }}
            </h4>

            <div class="product-meta">
              <AddToCartDessert
                :isAdmin="isAdmin"
                :dessert="dessert"
              ></AddToCartDessert>
            </div>
          </div>

          <div
            class="description"
            :style="{ color: listItemDescriptionColorTheme }"
          >
            {{ translate("description", dessert) }}
          </div>

          <Allergens :product="dessert"></Allergens>
          <div v-if="dessert.isAllowProductStory">
            <v-btn
              class="mt-3 gradient-border"
              outlined
              small
              fab
              color="white"
              @click="storyDialogAction(dessert.productStory)"
            >
              <v-icon style="color: black !important;">mdi-camera</v-icon>
            </v-btn>
          </div>
        </li>
      </template>
    </div>
    <StoryDialog
      v-if="storyDialog && storyUrl !== ''"
      :openDialog.sync="storyDialog"
      :storyUrl="storyUrl"
    />
  </div>
</template>

<script>
import AddToCartDessert from "../../cart/AddToCartDessert";
import Allergens from "../Allergens/Allergens";
import StoryDialog from "@/components/admin/product/productstory/StoryDialog";

export default {
  name: "ListDessert",
  props: {
    categoryName: String,
    dessertByCategory: Array,
    subCategories: Array,
    isAdmin: Boolean
  },
  components: {
    AddToCartDessert,
    Allergens,
    StoryDialog
  },
  data() {
    return {
      storyDialog: false,
      storyUrl: ""
    };
  },
  methods: {
    storyDialogAction(videoUrl) {
      if (videoUrl !== "" && videoUrl !== undefined) {
        this.storyUrl = videoUrl;
        this.storyDialog = true;
      }
    },
    hasSubCategory(id) {
      return this.getSubCategoryName(id) !== "";
    },
    getSubCategoryName(id) {
      const subCategory = this.subCategories.find(
        subCategory => id === subCategory.id
      );
      return subCategory ? subCategory.name : "";
    },
    dessertGroupedBy(products, key = "sub_category_id") {
      return this.arrayGroupBy(products, key);
    }
  }
};
</script>
